import { useLazyQuery } from '@apollo/client';
import { useQuery } from './useQuery';
import getSEOLinksQuery from '../queries/seolinks/getSEOLinks';

const useSEOLinks = ({
  path,
  ssr = true,
  skip = false,
  lazy = false
}) => {
  const Query = getSEOLinksQuery();

  const opts = {
    ssr,
    skip,
    errorPolicy: 'all',
    variables: {
      path,
    },
  };

  if (lazy) {
    return useLazyQuery(Query, opts);
  }
  return useQuery(Query, opts);

};

export default useSEOLinks;
